import {
  POST_SCHOOL_SUBSIDY_ORDERS_SETTINGS_APPLY,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/subsidy_orders_settings_apply/post'

import { SubsidyOrdersSettingsApplyParams } from 'app/common/types/food/schools/subsidyOrdersSettingsApply'

import { api } from 'app/api'

export const useSubsidyOrdersSettingsApply = ({
  params,
}: {
  params: SubsidyOrdersSettingsApplyParams
}) => {
  const request = async () => {
    const res = await api.request(POST_SCHOOL_SUBSIDY_ORDERS_SETTINGS_APPLY, {
      error: 'Не удалось применить к текущим справкам',
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })

    return res
  }

  return request
}
